import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import MobileLayout from "@/components/layouts/MobileLayout.vue";
import MainLayout from "@/components/layouts/MainLayout.vue";
import NewChatContainer from "@/components/chat/chatContainer/NewChatContainer/NewChatContainer.vue";
import NewChatMobileOneToOneChat from "@/components/chat/chatContainer/NewChatMobileOneToOneChat.vue";
import ChatSidebar from "@/components/chat/chatSidebar/ChatSidebar.vue";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { LayoutTypes } from "@/store/app/state";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewChat',
  setup(__props) {

const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);

return (_ctx: any,_cache: any) => {
  return (_unref(layoutType) === _unref(LayoutTypes).DESKTOP)
    ? (_openBlock(), _createBlock(MainLayout, { key: 0 }, {
        default: _withCtx(() => [
          _createVNode(MobileLayout, null, {
            default: _withCtx(() => [
              _createVNode(ChatSidebar)
            ]),
            _: 1
          }),
          _createVNode(NewChatContainer)
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(MobileLayout, { key: 1 }, {
        default: _withCtx(() => [
          _createVNode(NewChatMobileOneToOneChat)
        ]),
        _: 1
      }))
}
}

})